import { render, staticRenderFns } from "./priority-chicklet.vue?vue&type=template&id=438777f6&"
import script from "./priority-chicklet.vue?vue&type=script&lang=ts&"
export * from "./priority-chicklet.vue?vue&type=script&lang=ts&"
import style0 from "./priority-chicklet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports